"use client";

import { useState } from "react";
import { FaStar } from "react-icons/fa6";

interface StarRatingProps {
  name: string;
  value?: number;
  onChange: (rating: number) => void;
  readonly?: boolean;
  size?: number;
  className?: string;
}

export const StarRating = ({
  name,
  value = 0,
  onChange,
  readonly = false,
  size = 20,
  className = "",
}: StarRatingProps) => {
  const [hover, setHover] = useState(0);

  const handleClick = (rating: number) => {
    if (!readonly) {
      onChange(rating);
    }
  };

  const handleMouseEnter = (rating: number) => {
    if (!readonly) {
      setHover(rating);
    }
  };

  const handleMouseLeave = () => {
    if (!readonly) {
      setHover(0);
    }
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {[...Array(5)].map((_, index) => {
        const ratingValue = index + 1;
        const isFilled = ratingValue <= (hover || value);

        return (
          <button
            key={index}
            type="button"
            className={`transition-colors duration-150 ${
              readonly ? "cursor-default" : "cursor-pointer hover:scale-110"
            } ${isFilled ? "text-yellow-400" : "text-gray-300"}`}
            onClick={() => handleClick(ratingValue)}
            onMouseEnter={() => handleMouseEnter(ratingValue)}
            onMouseLeave={handleMouseLeave}
            disabled={readonly}
            title={`${ratingValue} star${ratingValue !== 1 ? "s" : ""}`}
          >
            <FaStar size={size} />
          </button>
        );
      })}
      <input type="hidden" name={name} value={value} />
    </div>
  );
};
